import { ChipColor } from 'components/Chip/Chip';

export const userRoleFormatter = (role: string) => {
    switch (role) {
        case 'manager':
            return 'Manager';
        case 'assistant':
            return 'Assistant';
        case 'user':
            return 'Personne soutenue';
        default:
            return role;
    }
};

export const mdphFormatter = (mdph: string) => {
    switch (mdph) {
        case 'yes':
            return 'Oui';
        case 'pending':
            return 'En cours';
        case 'no':
            return 'Non';
        default:
            return 'Inconnu';
    }
};

type Status = {
    label: string;
    color: ChipColor;
};

export const statusMap: Record<string, Status> = {
    pending: {
        label: 'En attente',
        color: 'waiting'
    },
    // active: {
    //     label: 'Actif',
    //     color: 'active'
    // },
    // inactive: {
    //     label: 'Inactif',
    //     color: 'inactive'
    // },
    waking: {
        label: 'Veille',
        color: 'waking'
    },
    // outgoing: {
    //     label: 'Sortie',
    //     color: 'out'
    // },
    punctual: {
        label: 'Ponctuel',
        color: 'punctual'
    },
    regular: {
        label: 'Régulier',
        color: 'regular'
    },
    intensive: {
        label: 'Intensif',
        color: 'intensive'
    }
};
